// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__5hQKn","gfeWrapper":"CalendarEvent_gfeWrapper__24W2H"};